import type { AssociationType } from '@/lib/crm/core/SchemaClient';

import type { CrmCreateField } from './types';

/**
 * Whether a field is currently shown: its `condition` (if any) holds for the
 * current values, and — for an association — its type has loaded and
 * survived the form's domain-kind filter.
 */
export function isFieldVisible(
  field: CrmCreateField,
  formData: Record<string, unknown>,
  associationTypesByName: ReadonlyMap<string, AssociationType>
): boolean {
  if (field.condition && !field.condition(formData)) {
    return false;
  }
  if (field.kind === 'association') {
    return associationTypesByName.has(field.associationType);
  }
  return true;
}

/** Stable React key for a field within its section. */
export function fieldKey(field: CrmCreateField): string {
  return field.kind === 'association'
    ? `assoc:${field.associationType}`
    : `${field.kind}:${field.property}`;
}
